export const calculations = {
    "wattsPerSquareFoot" : 7,
    "baseGeneratorSize": 6000,
    "baseApplianceOffset": 2000,
    "electricBillFactor": 7.4
};

